import type { TFunction } from 'i18next'

export type LoginModalLabels = {
  title: string
  confirm: string
  discard: string
  placeholder: string
}

// Header/button labels for the email -> code sign-in modal, resolved at render
// time so they follow a late switch to fr-CA. Pages differ only in the email
// step title and the code step's confirm button.
export const getLoginModalLabels = (
  t: TFunction,
  mode: string,
  { emailTitle, codeConfirm }: { emailTitle: string; codeConfirm: string }
): LoginModalLabels =>
  mode === 'code'
    ? { title: t('loginModal.confirmCode'), confirm: codeConfirm, discard: t('common.back'), placeholder: '970909' }
    : { title: emailTitle, confirm: t('common.continue'), discard: t('common.close'), placeholder: t('common.email') }
